<file-manager
        [readonly]="config.disabled">
</file-manager>
